<template>
  <audio
    controls
    :src="audio.src"
    loop="true"
    class="hidden"
    preload="auto"
    ref="appAudio">
        Your browser does not support the
        <code>audio</code> element.
   </audio>
</template>

<script>
export default {
  name: 'AudioPlayer',
  props:{
    route:{
      required: true,
      type: String
    }
  },
  data(){
    return{
      currentRoute: this.$route.name,
      isPlaying: false,
      audio:{
        src: 'https://blissing.s3-us-west-1.amazonaws.com/music/LadyJaneLoop2.mp3',
      },
      tracks:{
        Start: 'https://blissing.s3-us-west-1.amazonaws.com/music/LadyJaneLoop2.mp3',
        DeepInfo: 'https://blissing.s3-us-west-1.amazonaws.com/music/Eno+-+An+Ending+Loop.mp3',
        Invitation: 'https://blissing.s3-us-west-1.amazonaws.com/music/Niklas+Paschburg+-+Sand+Whirling+Loop.mp3',
        ForMarkOnly: 'https://blissing.s3-us-west-1.amazonaws.com/music/Deep+Nothing_Loop1_201019.mp3'
      }
    }
  },
  methods:{
    startNewMusic(data){
      this.audio.src = this.tracks[data];
      // this.$refs.appAudio.load();
      // this.$refs.appAudio.play();

      fetch(this.audio.src, {mode: 'no-cors'})
        .then(response => response.blob())
        .then(() => {
          // this.player.loading = true;
          //this.$refs.audio.srcObject = blob;
          return this.$refs.appAudio.play();
        })
        .then(() => {
          // Audio playback started ;)
          // this.player.playbackErrors = 0;

          this.isPlaying = true;
        })
        .catch(e => {
          // Audio playback failed ;(
          console.log(e);
        });

    },
    stopMusic(){
      this.$refs.appAudio.pause();
      this.$refs.appAudio.currentTime = 0;
    }
  },
  mounted(){
    Event.$on('playAudio', (data) => { this.startNewMusic(data)});
    Event.$on('stopAudio', () => { this.stopMusic()});
  }
}
</script>
